import { useCallback, useRef, useState } from "react";

export default function usePartialState<T>(initialState: Partial<T> = {}) {
  const initialStateBackup = useRef(initialState);
  const [s, _set] = useState(initialState);

  const set = useCallback((update: typeof initialState) => {
    _set((oldState) => ({ ...oldState, ...update }));
    return;
  }, []);

  const reset = useCallback(() => {
    _set(() => ({ ...initialStateBackup.current }));
    return;
  }, []);

  const arr: [typeof initialState, typeof set, typeof reset] = [s, set, reset];
  return arr;
}
